import { CustomIntegrationInstaller } from "../types";

const iamAssessmentInstructions: CustomIntegrationInstaller["iam-assessment"]["instructions"] =
  () => ({
    help: (
      <>
        Custom assessment allows P0 to assess custom resources and identities
        that you define. This component enables you to upload custom data for
        security analysis.
      </>
    ),
    commands: {
      shell: [],
      iac: [],
    },
  });

export const customIamAssessmentInstaller: CustomIntegrationInstaller["iam-assessment"] =
  {
    instructions: iamAssessmentInstructions,
    items: {},
  };
